import { get } from "idb-keyval";
import { enable_host_autoselect_key } from "./constants";

export default async () => (await get(enable_host_autoselect_key)) ?? true;
